<template>
  <div v-if="showNews" class="news">
    <div class="newsTitle">新闻中心</div>
    <div class="newsEn">NEWS CENTER</div>
    <van-swipe :autoplay="3000" class="swipe">
      <van-swipe-item v-for="(item, index) in arr" :key="index">
        <div @click="jumpLink(item.url)" class="newsBox">
          <img :src="item.cover" alt="" class="newsBoxImg" />
          <div class="newsBoxBottom">
            <div class="newsBoxTitle">{{ item.title }}</div>
            <div class="newsBoxContent">{{ item.desc }}</div>
            <div class="newsBoxDetail">
              <div class="newsBoxDetailText">查看详情</div>
              <img
                src="https://p4.ssl.qhimg.com/t110b9a9301e650fa891a7c3676.png"
                alt=""
                class="newsBoxDetailImg"
              />
            </div>
          </div>
        </div>
      </van-swipe-item>
    </van-swipe>
    <img src="https://p0.ssl.qhimg.com/t110b9a9301ab53d2592ad5dc28.png" alt="" class="newsBg" />
  </div>
</template>

<script setup>
import { ref, onBeforeMount } from 'vue'
import { getNews } from '@/api/2024/index.js'

const arr = ref([])
const showNews = ref(true)

onBeforeMount(async () => {
  await fetch()
})

const jumpLink = (url) => {
  if (url) {
    window.open(url, '_blank')
  }
}

const fetch = () => {
  getNews('297785').then((res) => {
    let news = res.data.data.list
    arr.value = news
  }).catch(error => {
    showNews.value = false
  })
}
</script>

<style lang="scss" scoped>
.news {
  opacity: 1;
  background: #f3f3f3;
  padding: 32px 16px 40px;
  &Title {
    font-family: Source Han Sans;
    font-size: 18px;
    font-weight: 500;
    line-height: 24px;
    letter-spacing: 0px;
    font-variation-settings: 'opsz' auto;
    /* Gray 中性/gray-9 */
    color: #242933;
  }
  &En {
    font-family: Source Han Sans;
    font-size: 12px;
    font-weight: normal;
    line-height: 18px;
    letter-spacing: 0px;
    font-variation-settings: 'opsz' auto;
    /* Gray 中性/gray-7 */
    color: #8a9099;
    margin: 2px 0 16px;
  }
  &Box {
    border-radius: 16px;
    opacity: 1;
    background: rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(120px);
    &Bottom {
      padding: 16px 12px 20px;
    }
    &Title {
      font-family: Source Han Sans;
      font-size: 14px;
      font-weight: 500;
      line-height: 28px;
      letter-spacing: 0px;
      font-variation-settings: 'opsz' auto;
      /* Gray 中性/gray-9 */
      color: #242933;
      margin-bottom: 4px;
      height: 56px;
    }
    &Content {
      font-family: Source Han Sans;
      font-size: 12px;
      font-weight: normal;
      line-height: 22px;
      text-align: justify; /* 浏览器可能不支持 */
      letter-spacing: 0px;
      font-variation-settings: 'opsz' auto;
      /* Gray 中性/gray-8 */
      color: #525966;
      text-align-last: left;
      text-align: justify;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: normal;
    }
    &Img {
      border-radius: 16px 16px 0 0;
      width: 100%;
    }
    &Detail {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 10px;
      &Text {
        font-family: Source Han Sans;
        font-size: 12px;
        font-weight: normal;
        line-height: 22px;
        text-align: justify;
        color: #525966;
        margin-right: 4px;
      }
      &Img {
        width: 12px;
        height: 12px;
      }
    }
  }
  &Bg {
    position: absolute;
    bottom: 52px;
    left: 0;
    width: 82px;
  }

  :deep(.van-swipe__indicators) {
    position: relative;
    margin-top: 27px;
    justify-content: center;
  }
  .swipe {
    --van-swipe-indicator-active-background: #525966;
    --van-swipe-indicator-inactive-background: #dfe1e6;
    --van-swipe-indicator-size: 8px;
    z-index: 20;
  }
}
</style>
